import ContextProvider from './ContextProvider';
import ContextConsumer from './ContextConsumer';

export const AppContextProvider = ContextProvider;
export const AppContextConsumer = ContextConsumer;
